var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgApplications(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 22,
    viewBox: "0 0 18 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 3.0332H15C15.5304 3.0332 16.0391 3.23221 16.4142 3.58645C16.7893 3.94068 17 4.42113 17 4.92209V18.1443C17 18.6453 16.7893 19.1257 16.4142 19.48C16.0391 19.8342 15.5304 20.0332 15 20.0332H3C2.46957 20.0332 1.96086 19.8342 1.58579 19.48C1.21071 19.1257 1 18.6453 1 18.1443V4.92209C1 4.42113 1.21071 3.94068 1.58579 3.58645C1.96086 3.23221 2.46957 3.0332 3 3.0332H5",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 1.7832H6C5.73478 1.7832 5.48043 1.88856 5.29289 2.0761C5.10536 2.26363 5 2.51799 5 2.7832V4.7832C5 5.04842 5.10536 5.30277 5.29289 5.49031C5.48043 5.67785 5.73478 5.7832 6 5.7832H12C12.2652 5.7832 12.5196 5.67785 12.7071 5.49031C12.8946 5.30277 13 5.04842 13 4.7832V2.7832C13 2.51799 12.8946 2.26363 12.7071 2.0761C12.5196 1.88856 12.2652 1.7832 12 1.7832V1.7832Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 9.9082L7 14.9082",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5 12.9082L7 15.9082",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplications);
export default __webpack_public_path__ + "static/media/applications.9176f264ad8e75f69f9b607cd47b8bf0.svg";
export { ForwardRef as ReactComponent };